<div class="bf-home">

  <!-- ==================================================
       INTRODUCTION / HERO
  ================================================== -->

  <app-hero></app-hero>


  <!-- ==================================================
       SUMMARY
       Source: 7 / 2 / 3
  ================================================== -->

  <section
    id="bf-summary"
    class="bf-summary"
  >

    <div class="bf-summary__grid">

      <div class="bf-summary__intro">

        <h3>
          NEM CSAK EGY HAJVÁGÁS.
        </h3>

        <h2>
          Ez életstílus.
        </h2>

        <div class="bf-summary__copy">

          <p>
            Azoknak a stílusos, fiatal szakembereknek vagyunk itt, akiknek
            magasabb minőségű szolgáltatásra van szükségük — olyan személyre
            szabott hajvágásra, amely nemcsak illik hozzájuk, hanem ki is
            emeli az életstílusukat.
          </p>

          <p>
            Ezzel a filozófiával a szemünk előtt született meg a Bonefade
            Barbers. Egy szalon, amely kizárólag a legkiválóbb hajvágásokat
            kínálja megbecsült ügyfeleinek — ahol pontosan azt kapod, amit
            kérsz, módszeres precizitással.
          </p>

          <p>
            A precizitás, a személyre szabottság és a valódi minőség az, ami
            megkülönbözteti a Bonefade Barberst a többiektől.
          </p>

        </div>

      </div>


      <div class="bf-summary__spacer"></div>


      <div class="bf-summary__appointment">
        <app-appointment-info></app-appointment-info>
      </div>

    </div>

  </section>


  <!-- ==================================================
       LARGE IMAGE
  ================================================== -->

  <section class="bf-large-image">

    <div
      class="bf-large-image__parallax-host"
      data-parallax-host
    >

      <div
        class="bf-large-image__parallax-item"
        bfParallax
        data-parallax-item
      >

        <figure
          class="bf-large-image__image-wrapper"
          data-parallax-image-wrapper
        >

          <img
            src="/images/bonefade-source/SQS_DK_carlos_0303-copy.jpg"
            alt="Borbély előkészíti az ügyfelet"
            class="bf-large-image__image"
          />

        </figure>

      </div>

    </div>

  </section>


  <!-- ==================================================
       TESTIMONIALS
       Source:
       7 / 1 / 4
  ================================================== -->

  <section class="bf-testimonials">

    <div class="bf-testimonials__grid">

      <!-- =========================================
           7 / 12
           OUR CLIENTS
      ========================================== -->

      <div class="bf-testimonials__clients">

        <!-- Source HTML block -->
        <div class="bf-testimonials__html-block">

          <h2>
            Ügyfeleink
          </h2>

        </div>


        <!-- Source horizontal rule block -->
        <div class="bf-testimonials__rule-block">

          <hr />

        </div>


        <!-- =====================================
             MAX
        ====================================== -->

        <div class="bf-quote-block">

          <figure class="bf-quote-block__contents">

            <blockquote>

              <span>“</span>Bulls a legjobb. Már kétszer jártam nála, és
              imádom a tiszta vonalú hajvágásait. Meghallgatta, mit
              szeretnék, és most már nagyon jól érzem magam, ha rábízom a
              döntést — ami nálam nem gyakori.<span>”</span>

            </blockquote>

            <figcaption class="bf-quote-source">
              — MAX
            </figcaption>

          </figure>

        </div>


        <!-- =====================================
             RONAK
        ====================================== -->

        <div class="bf-quote-block">

          <figure class="bf-quote-block__contents">

            <blockquote>

              <span>“</span>Bulls egy igazi legenda és profi. Nagyon válogatós
              vagyok a hajvágásaimmal kapcsolatban, ezért amikor 6 hónapja
              Chicagóból ideköltöztem, kicsit aggódtam. Kipróbáltam több
              mint 5 szalont/borbélyt, és 30-150 dollár közötti árakat
              fizettem, de egyik sem volt olyan lenyűgöző, mint Bulls. Azóta
              3 hetente visszajárok hozzá, és ezt folytatni is fogom,
              bárhol is lakjak Manhattanben.<span>”</span>

            </blockquote>

            <figcaption class="bf-quote-source">
              — RONAK
            </figcaption>

          </figure>

        </div>


        <!-- =====================================
             TOM
        ====================================== -->

        <div class="bf-quote-block">

          <figure class="bf-quote-block__contents">

            <blockquote>

              <span>“</span>Két hajvágáson és teljes borotválkozáson is túl
              vagyok már Bullsnál. Remek borbély, odafigyel a részletekre, és
              vicces fickó is. Mindkét alkalommal nagyon elégedett voltam, a
              borotválkozás pedig szuper relaxáló és alapos élmény.<span>”</span>

            </blockquote>

            <figcaption class="bf-quote-source">
              — TOM
            </figcaption>

          </figure>

        </div>

      </div>


      <!-- =========================================
           1 / 12
           SPACER
      ========================================== -->

      <div class="bf-testimonials__spacer"></div>


      <!-- =========================================
           4 / 12
           OUR BARBERS
      ========================================== -->

      <div class="bf-testimonials__barbers">

        <!-- Source HTML block -->
        <div class="bf-testimonials__html-block">

          <h2>
            Borbélyaink
          </h2>

        </div>


        <!-- Source horizontal rule block -->
        <div class="bf-testimonials__rule-block">

          <hr />

        </div>


        <!-- Source image block -->
        <div class="bf-barber-image-block">

          <figure class="bf-barber-image-figure">

            <div class="bf-barber-image-container">

              <img
                src="/images/bonefade-source/roli_barber.png"
                alt=""
                class="bf-barber-image"
              />

            </div>

          </figure>

        </div>


        <!-- Source HTML block -->
        <div class="bf-barber-copy-block">

          <h3>
            <strong>BULLS</strong>
          </h3>

          <p>
            Az East Village környékén jól ismert modern hajvágásairól,
            Bulls büszke a legapróbb részletekre is — azokra, amelyek egy
            igazán jó frizurát tesznek vagy törnek meg.
          </p>

        </div>

      </div>

    </div>

  </section>


  <!-- ==================================================
       PRICE LIST (tablet/mobile only -- desktop keeps the
       standalone /arak page; see home.scss's max-width: 1023px
       rule and header/footer/hero's "Árak" links, which scroll
       here below that breakpoint instead of routing)
  ================================================== -->

  <app-price-list id="price-list" class="bf-home__price-list"></app-price-list>


  <!-- ==================================================
       GALLERY GRID (tablet/mobile only -- desktop keeps the
       standalone /galeria page; see home.scss's max-width: 1023px
       rule and header/footer/hero's "Galéria" links, which scroll
       here below that breakpoint instead of routing)
  ================================================== -->

  <app-gallery-grid id="gallery-grid" class="bf-home__gallery-grid"></app-gallery-grid>

</div>
